import * as React from "react";
import { Action } from "../../../../../../Actions/Action";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ApplyModel } from "../../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import {
    getISTPaymentAmount,
    pensionInstrumentSelectionToInstrumentSelection,
} from "../../../../../../../Shared/IST/Components/Shared/Utils";
import { InvestmentSelectionTool as IST } from "../../../../../../../Shared/IST/InvestmentSelectionTool";
import { ProcessType } from "../../../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { WizardLinter, EWizardLinterStatus } from "../../../../../../../Shared/Process/Process/WizardLinter";
import { SubAccountTypeHelper } from "../../../../Common/Helpers/SubAccountTypeHelper";
import { BankAccountOwnerPaymentTypeMap, PaymentType } from "../../../../Common/Resource/Contents";
import { EWizardLinterHelper } from "../../../Resource/EWizardLinterHelper";
import { AdviserContextStoreStatic } from "../../../Stores/Variable";
import { TreasuredAssetsStore } from "../../../../../../Stroes/Variable";
import { HierarchyIdHelper } from "../../../../../../../Shared/Common/HierarchyIdHelper";

interface InvestmentSelectionToolProps extends IProcessComponentProps {
    data: ApplyModel;
    treasuredAssetProductIds: number[];
    onTreasuredAssetsStoreChange: () => void;
    onChangeTreasuredAssets: (subAccountInstructionId, productId, value) => void;
}

interface InvestmentSelectionToolState { }

export class InvestmentSelectionTool extends ProcessComponent<
    InvestmentSelectionToolProps,
    InvestmentSelectionToolState
> {
    constructor(props: any) {
        super(props);
        this.subscribeToStore(TreasuredAssetsStore, () => this.props.onTreasuredAssetsStoreChange());
    }

    componentDidMount() {
        super.componentDidMount();
        const subAccountInstructionId = HierarchyIdHelper.generateHierarchyId(this.props.data.GiaModel.HierarchyId)
            .entityId;
        Action.getInstructionTreasuredAssetsProductIds(subAccountInstructionId);
    }

    public render(): JSX.Element {
        const { onChange, data, onChangeTreasuredAssets, treasuredAssetProductIds, onOrderTypeChange } = this.props;
        const paymentAmount = getISTPaymentAmount(data?.GiaModel, "GiaTransfers");
        const accountsFromExisting = data.AllBankAccounts || [];
        const bankAccountInstructionsFiltered =
            (data.BankAccountInstructions || []).filter(
                (x) => BankAccountOwnerPaymentTypeMap[x.Owner].indexOf(PaymentType.Client) != -1
            ) || [];

        const bankAccounts = [...accountsFromExisting, ...bankAccountInstructionsFiltered];
        const modelData = JSON.parse(JSON.stringify(data?.GiaModel));
        modelData.CashInstrument = data.CashInstrument;
        modelData.OwnerHierarchyId = data.OwnerHierarchyId;

        const adviser = AdviserContextStoreStatic.getData();
        const hasSipp = data.SelectedProducts.some((ele) =>
            SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType)
        );
        const hasIsa = data.SelectedProducts.some((ele) => ele.SubAccountType == SubAccountType.StocksIsa);
        return (
            <WizardLinter
                status={EWizardLinterStatus.PleaseCheck}
                enabled={EWizardLinterHelper.shouldDisplay(SubAccountType.InvestmentAccount)}
            >
                <h2 className="mb-20">Investment selection</h2>
                <IST
                    withReRegistrationTransferIn={false}
                    data={data?.GiaModel?.InstrumentSelections}
                    modelData={modelData}
                    onRef={(ref) => this.appendChild(ref)}
                    onChange={(changes) => 
                        {
                            if (changes.orderType) {
                                onOrderTypeChange(changes.orderType);
                            } else {
                                this.onDataChange(
                                    (changes) => this.onDataChange(onChange, changes, data, "GiaModel"),
                                    changes,
                                    data.GiaModel,
                                    "InstrumentSelections"
                                )
                            }
                        }
                    }
                    from={hasSipp ? SubAccountType.Sipp : hasIsa ? SubAccountType.StocksIsa : null}
                    fromData={
                        hasSipp
                            ? pensionInstrumentSelectionToInstrumentSelection(
                                data.PensionApply?.PreRetirementInstrumentSelections,
                                data.PensionApply?.PostRetirementInstrumentSelections,
                                data.CashInstrument
                            )
                            : hasIsa
                                ? this.props.data.IsaModel?.InstrumentSelections
                                : null
                    }
                    showErrorMsgPopUp={(msg) => this.props.showErrorMsgPopUp(msg)}
                    type={ProcessType.NB}
                    hiercharyId={data.SubaccountInstructionHierarchyId}
                    headAccountHierarchyId={data.ExistingAccountHierarchyId}
                    companyCode={adviser?.Company}
                    claccountId={this.props.data.ClAccountId}
                    product={SubAccountType.InvestmentAccount}
                    paymentAmount={{ Amount: paymentAmount, Currency: CurrencyCode.GBP }}
                    bankAccounts={bankAccounts}
                    onBankChange={(bankInfo) => {
                        const banks = data.BankAccountInstructions.concat(bankInfo);
                        onChange({ BankAccountInstructions: banks });
                    }}
                    onDistributionDividendOptions={(changes) => {
                        this.onDataChange(
                            (changes) => this.onDataChange(onChange, changes, data, "GiaModel"),
                            changes,
                            data.GiaModel,
                            "DistributionDividendOptions"
                        );
                    }}
                    decisionMakerHierarchyId={data?.GiaModel?.HierarchyId}
                    accountAdviceType={data?.AccountAdviceType}
                    accountServiceProposition={data?.AccountServiceProposition}
                    onDecisionMakerChange={(v) => this.onDataChange(onChange, v, data, "GiaModel")}
                    treasuredAssetsProductIds={treasuredAssetProductIds}
                    onChangeTreasuredAssets={(productId, value) => {
                        onChangeTreasuredAssets(data.GiaModel.HierarchyId, productId, value);
                    }}
                />
            </WizardLinter>
        );
    }
}
